import React from 'react';
import PropTypes from 'prop-types';

// Without this a render error unmounts the whole tree and leaves an unexplained white page.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Partner promotions crashed:', error, info);
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (!error) return children;

    return (
      <div style={{ padding: 24, maxWidth: 760, margin: '80px auto', fontFamily: 'system-ui, sans-serif' }}>
        <h1 style={{ fontSize: 20, marginBottom: 8 }}>Something in this screen failed to render</h1>
        <p style={{ color: '#616161', marginBottom: 16 }}>
          The page has not saved anything it should not have. Reload to carry on, and send this to a
          developer.
        </p>
        <details>
          <summary style={{ cursor: 'pointer', fontSize: 13, color: '#616161' }}>
            Technical details
          </summary>
          <pre
            style={{
              background: '#FAFAFA', border: '1px solid #e3e3e3', borderRadius: 8,
              padding: 12, fontSize: 12, whiteSpace: 'pre-wrap', overflowX: 'auto', marginTop: 8,
            }}
          >
            {String(error && error.stack ? error.stack : error)}
          </pre>
        </details>
      </div>
    );
  }
}

ErrorBoundary.propTypes = { children: PropTypes.node };

export default ErrorBoundary;
